// import { rejectToAgent } from '@/API';
import { checkLinePrice, rejectToAgent, saveOrderContractInfo } from '@/API';
import { buildContractComplianceRequest, checkExportCompliance, isDomesticContract } from '@/libs/exportCompliance';

export default {
  methods: {
    async submit (val, cal) {
      const result = await this.cloudPrice();
      if (!result) {
        this.$refs.actions.loading = false;
        return;
      }
      if (Number(this.form.assignAll * 100 / this.form.actualSettlementAmount).toFixed(2) < 5) {
        this.$confirm('已分配比例小于5%, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.submitAction(val, cal);
        }).catch((e) => {
          console.error(e);
          this.$notify({
            type: 'info',
            message: '取消发布合同'
          });
          this.$refs.actions.loading = false;
        });
      } else {
        this.submitAction(val, cal);
      }
    },
    // 设置 云产品价格拦截
    async cloudPrice () {
      const params = [];
      const product = await this.$refs.product.productList;
      // 筛选 数组到parmas
      product.map((item) => {
        if (item.highlight === 1) {
          params.push({
            productCode: item.productCode,
            productName: item.productName,
            productPrice: item.beforeSplitProductPriceSigle
          });
        }
      });
      let result = await checkLinePrice(params);
      let json = result.data;
      if (json.status === '200') {
        if (json.data.length === 0) {
          return true;
        } else {
          let nameAllProduct = '';
          json.data.map((item) => {
            nameAllProduct += item.productName + ',';
          });
          // this.$message.error();
          this.$notify.error(nameAllProduct + '价格低于底线价，请驳回');
          return false;
        }
      } else {
        return false;
      }
    },
    submitActionBefore () {
      let contractFileList = this?.$refs?.contractFileRef ? this.$refs.contractFileRef.getContractList() : [];
      if (!contractFileList || contractFileList.length === 0) {
        return this.$confirm('当前合同没有上传附件，请确定是否继续发布合同？', '提示', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => true).catch(() => false);
      }

      return Promise.resolve(true);
    },
    async submitAction (val, cal) {
      let baseR = true;
      let product = {};
      let error = '';
      if (!val) {
        baseR = await this.$refs.baseInfo.validate();
      } else {
        baseR = await this.$refs.baseInfo.validatedrafts();
      }
      if (!baseR) {
        this.loading = false;
        cal(false);
        return;
      }
      if (val) {
        product = await this.$refs.product.validateDraft();
      } else {
        product = await this.$refs.product.validate();
      }
      let useRebateVO = this.$refs.freightInfo && this.$refs.freightInfo.validate();
      if (useRebateVO === false) {
        cal(false);
        return;
      }
      // 组件不存在增加默认值
      if (useRebateVO === undefined) {
        useRebateVO = {
          contractNum: baseR.contractInfo.contractNum,
          orderAmount: product.orderSales,
          projectName: baseR.contractInfo.projectName,
          rebateListVo: []
        };
      }
      if (baseR && product && useRebateVO) {
        val ? baseR.contractInfo.isDraft = true : baseR.contractInfo.isDraft = false;

        let newProductList = [];
        product.productList.forEach((item) => {
          item.authorizationEmail = this.form.authorizationEmail;
          item.serviceLife = item.productNum;
          newProductList.push(item);
        });
        if (val !== 1) {
          newProductList.forEach((item) => {
            if (!item.materialUnit) {
              error = `${item.materialNumberId}料号单位为空，请试试重新选择！`;
            }
          });
        }

        let contractDetail = {
          actualSettlementAmount: product.actualSettlementAmount,
          orderSales: product.orderSales,
          productServiceProviderA: this.form.productServiceProviderA,
          productServiceProviderB: this.form.productServiceProviderB,
          productServiceProviderC: this.form.productServiceProviderC,
          serviceSubjectName: this.form.serviceSubjectName,
          multiaddress: this.form.multiaddress
        };
        baseR.invoiceEmail = this.$refs.baseInfo.form.invoiceEmail; // 电票邮箱字段
        baseR.contractDetail = { ...baseR.contractDetail, ...contractDetail };

        if (error) {
          this.$notify.error(error);
          this.$refs.actions.loading = false;
          return;
        }

        if (!val) {
          let _result = await this.submitActionBefore();
          if (!_result) {
            this.$refs.actions.loading = false;
            return;
          }
        }

        this.loading = true;
        if (!val && isDomesticContract({ ...this.form, civilInternational: baseR.civilInternational })) {
          const decision = await checkExportCompliance(this,
            buildContractComplianceRequest(this.form, baseR, newProductList, this.$refs.product.address));
          if (!decision.allowBusiness) {
            this.loading = false;
            this.$refs.actions.loading = false;
            cal(false);
            return;
          }
        }
        saveOrderContractInfo({ ...baseR, contractProductInfos: newProductList, useRebateVO }).then((res) => {
          let json = res.data;
          this.loading = false;
          cal(false);
          if (json.status === '200') {
            if (val) {
              this.$router.replace({ name: 'orderPersionDrafts' });
            } else {
              this.$router.replace({ name: 'orderPersionContractList' });
            }
            this.$message.success('操作成功');
          } else {
            this.$refs.actions.dialogVisible = false;
            // this.$message.error(json.err);
            cal(false);
          }
        }).catch(() => {
          this.loading = false;
          cal(false);
        });
      } else {
        this.loading = false;
        cal(false);
      }
    },
    Reject (cal) {
      rejectToAgent(this.form.id).then((res) => {
        cal();
        let json = res.data;
        if (json.status === '200') {
          this.$router.replace({
            name: 'orderPersionContractList'
          });
        }
      }).catch(() => {
        cal();
      });
    },
    suggestionInfo () {
      this.$refs.rejected.showRejectDialog();
    }
  }
};
